import React from "react";

import { CssBaseline } from "@mui/material";
import { useRoutes } from "react-router-dom";
import { MatxTheme } from "./components";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ProfileRoleProvider } from "./contexts/ProfileRoleContext";
import Routes from "./routes";
import ToastConfig from "./lib/ToastConfig";

const App = () => {
  const routes = Routes();
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <AuthProvider>
        <MatxTheme>
          <ToastConfig />
          <ProfileRoleProvider>
            <CssBaseline />
            {content}
          </ProfileRoleProvider>
        </MatxTheme>
      </AuthProvider>
    </SettingsProvider>
  );
};

export default App;
